import Handlebars from "../handlebars/handlebars";
import bodyLockService from "../ui/bodyLockService";
import gutenbergService from "../_services/gutenbergService";
import menuService from "../_services/menuService";
import "../avatar/avatar";
import gHeaderNavHtml from "./gHeaderNav.hbs"
import gHeaderMainSupNavHtml from "./gHeaderMainSupNav.hbs"
import "./gheader.css"
import headerMenuProducts from "../_data/headerMenuProducts";

const HEADER_ELE = '.js--element-gHeader';
const HEADER_MAIN_ELE = '.js--element-headerMain';
const HEADER_NAV_ELE = '.js--element-headerNav';
const HEADER_NAV_ACTION = '.js--action-headerNav';
const HEADER_AI_ACTION = '.js--action-siHeader';
const TOGGLE_ELE = '.js--element-toggle';
const TOGGLE_ACTION = '.js--action-trigger';
const TOGGLE_CLOSE_ACTION = '.js--action-closeToggle';
const TOGGLE_SUP_MENU = '.js--action-revealSubMenu'
const GLOBAL_MESSAGE_ELE = '.js--element-globalMessageBox';
const NAV_ITEM_NAME_ELE = '.gHeader-nav-list-item-name';
const SUB_NAV_TARGET_ELE = '.gHeader-subNav-list-item__target';
const SUB_NAV_MENU_CONTAINER_ELE = '.gHeader-subNav-list-item__sub-menu-container';
const CSS_IS_OPEN = 'isOpen';
const CSS_SUB_NAV_ARROW = 'gHeader-subNav-list-item__target_arrow';
const CSS_SUB_NAV_REVEAL = 'reveal_sub_menu';
const CSS_SUB_NAV_WIDTH = 'reveal_subnav_width';
const breakPointWidth = 1200; // in pixels — mobile/desktop header split
const subNavBreakPointWidth = 1185; // in pixels — desktop treatment for the supplementary subnav
const FOCUS_SETTLE_DELAY = 10; // ms — lets focus settle before deciding the nav lost it (tuned for fast Tab traversal)
const gHeaderEle  = document.querySelector(HEADER_ELE);
const mainContainer = gHeaderEle.querySelector(HEADER_MAIN_ELE);
const mMenuContainer = gHeaderEle.querySelector(HEADER_NAV_ELE);
const mMenuTrigger = gHeaderEle.querySelector(HEADER_NAV_ACTION);
const mainSupNavContainer = mainContainer.querySelector('.js--element-mainSupMenu');
let scrollPos = 0;
let width = window.innerWidth;
let scrollDirectionDisabled = false;

// ─── Desktop flyout state (populated by initDesktopFlyout after menus render) ───
let navItems = [];
let navIndicator = null;
let activeIndex = -1;        // currently open item index (-1 = closed)
let isOpening = false;       // true while the clip-path reveal is still animating
let flyoutCloseDelay = 400;  // ms before nav closes after leaving all items
let flyoutIntentDelay = 60;  // ms to confirm hover intent before first open
let flyoutCloseAnim = 440;   // ms — clip-path open/close duration
const flyoutTimers = {
    intent: null,     // debounce before first open
    close: null,      // delay before closing nav on mouseleave
    closing: null,    // clears .navClosing once the close animation ends
    openSettle: null, // clears isOpening once the open animation finishes
};

// ─── Subnav supplementary menu elements (assigned by initSubNavElements after render) ───
let subNavTarget = null;
let subNavMenuContainer = null;

renderMenus();

window.addEventListener('resize', handleWindowResize);

function handleWindowResize () {
    if (window.innerWidth === width) {
        return;
    }

    if (document.querySelectorAll('.' + CSS_IS_OPEN).length > 0 && width >= breakPointWidth) {
        closeHeaderNav()
    }

    width = window.innerWidth;
    initViews();
}

function renderMenus () {

    Promise.allSettled([
        Promise.allSettled(headerMenuProducts.map(id => menuService.getMenu(id))),
        menuService.getMenu(mainSupNavContainer.dataset.menuId),
    ])
        .then(([mMenuResults, supMenu]) => {
            // Merge all menu children into a single list
            const mergedChildren = mMenuResults.value
                .filter(r => r.status === 'fulfilled' && r.value?.children)
                .flatMap(r => r.value.children);

            const mergedMenu = { active: mergedChildren.length > 0, children: mergedChildren };
            mMenuContainer.innerHTML = gHeaderNavHtml(mergedMenu);
            mainSupNavContainer.innerHTML = gHeaderMainSupNavHtml(supMenu.value);
        })
        .then(initSubNavElements)
        .then(initViews)
        .then(initFlyoutStaggerSystem)
        .then(initDesktopFlyout);
};

// The subnav supplement is rendered by renderMenus, so its elements can only
// be captured after the templates land in the DOM.
function initSubNavElements () {
    subNavTarget = document.querySelector(SUB_NAV_TARGET_ELE);
    subNavMenuContainer = document.querySelector(SUB_NAV_MENU_CONTAINER_ELE);
}

// ─── Activate flyout stagger system ───
// Tags each animating element with .flyoutStaggerItem and assigns the
// --flyout-* CSS custom properties that drive the open/close cascade.
function initFlyoutStaggerSystem () {
    document.querySelectorAll('.gHeaderMenu').forEach(menu => {
        const secondaryGroups = menu.querySelectorAll(
            '.gHeaderMenu-menuChild-content-featured-menus-secondary'
        );
        const shopAll = menu.querySelector('.gHeaderMenu-menuChild-content-featured-shopAll');
        const spotlight = menu.querySelector('.gHeaderMenu-menuChild-content-spotlight');
        let runningTotal = 0;

        secondaryGroups.forEach((group, groupIndex) => {
            const secLink = group.closest('.gHeaderMenu-menuChild-content-featured')
                ?.querySelector('.gHeaderMenu-menuChild-content-featured-menus-secondary-link');
            const tertiaryItems = group.querySelectorAll(
                '.gHeaderMenu-menuChild-content-featured-menus-tertiary > li'
            );

            if (secLink) {
                secLink.style.setProperty('--flyout-item-number', groupIndex + 1);
                secLink.style.setProperty('--flyout-group-number', groupIndex);
            }

            tertiaryItems.forEach((item, itemIndex) => {
                item.style.setProperty('--flyout-item-number', itemIndex + 1);
                item.style.setProperty('--flyout-group-number', groupIndex);
                runningTotal++;
            });
        });

        // Every secondary link and tertiary item joins the cascade (headers
        // beyond the first have no inline props and animate on the defaults).
        // --flyout-item-total drives the reverse-stagger durations on close.
        menu.querySelectorAll(
            '.gHeaderMenu-menuChild-content-featured-menus-secondary-link, ' +
            '.gHeaderMenu-menuChild-content-featured-menus-tertiary > li'
        ).forEach(el => {
            el.classList.add('flyoutStaggerItem');
            el.style.setProperty('--flyout-item-total', runningTotal);
        });

        if (shopAll) {
            shopAll.classList.add('flyoutStaggerItem');
            shopAll.style.setProperty('--flyout-item-number', runningTotal + 1);
        }

        // Spotlight goes last so it closes out the cascade
        if (spotlight) {
            spotlight.classList.add('flyoutStaggerItem');
            spotlight.style.setProperty('--flyout-item-number', runningTotal + 2);
            spotlight.style.setProperty('--flyout-item-total', runningTotal + 2);
        }
    });
}

// Reads a duration design token from vars.css as milliseconds ('s' or 'ms' units)
function readDurationToken (name, fallbackMs) {
    const raw = getComputedStyle(document.documentElement).getPropertyValue(name).trim();
    const value = parseFloat(raw);
    if (isNaN(value)) return fallbackMs;
    return Math.round(raw.endsWith('ms') ? value : value * 1000);
}

// ─── Wire up desktop flyout navigation ───
function initDesktopFlyout () {
    navItems = document.querySelectorAll('.gHeader-nav-list .gHeader-nav-list-item');
    navIndicator = document.createElement('div');
    flyoutCloseDelay = readDurationToken('--flyout-close-delay', 400);
    flyoutIntentDelay = readDurationToken('--flyout-intent-delay', 60);
    flyoutCloseAnim = readDurationToken('--duration-slow', 440);

    navIndicator.classList.add('gHeader-nav-indicator');
    mMenuContainer.appendChild(navIndicator);

    bindNavItemEvents();
    bindContainerEvents();
    bindSubNavSupplements();
}

function isDesktopNavViewport () {
    return window.innerWidth >= breakPointWidth;
}

// ─── Flyout timer helpers ───
// Every flyout timer runs through these so clearing and nulling always
// happen together.
function clearFlyoutTimer (name) {
    if (!flyoutTimers[name]) return;
    clearTimeout(flyoutTimers[name]);
    flyoutTimers[name] = null;
}

function startFlyoutTimer (name, callback, delay) {
    clearFlyoutTimer(name);
    flyoutTimers[name] = setTimeout(() => {
        flyoutTimers[name] = null;
        callback();
    }, delay);
}

function setNavItemExpanded (index, expanded) {
    navItems[index].querySelector(NAV_ITEM_NAME_ELE)?.setAttribute('aria-expanded', String(expanded));
}

function openItem (index) {
    const prevIndex = activeIndex;
    activeIndex = index;

    clearFlyoutTimer('close');

    // Re-opening mid-close — abort the close cascade
    clearFlyoutTimer('closing');
    mMenuContainer.classList.remove('navClosing');

    // Hover direction reversed onto the still-visible previous panel
    // (wasHoverOn, opacity 1) — it must restart its fade from 0 below,
    // or it snaps in at full opacity instead of crossfading.
    const returningToPrevious = navItems[index].classList.contains('wasHoverOn');

    // Only the immediately-previous item keeps wasHoverOn (A→B→C clears A's)
    navItems.forEach(item => item.classList.remove('wasHoverOn'));

    if (prevIndex >= 0 && prevIndex !== index) {
        navItems[prevIndex].classList.remove('hoverOn');
        navItems[prevIndex].classList.add('wasHoverOn');
        setNavItemExpanded(prevIndex, false);
    }

    navItems[index].classList.remove('wasHoverOn');
    if (returningToPrevious) navItems[index].offsetHeight; // force reflow so the fade starts at opacity 0
    navItems[index].classList.add('hoverOn');
    setNavItemExpanded(index, true);

    if (prevIndex < 0) {
        // First open — play the clip-path reveal. navOpening stays on for
        // the whole open session (it keeps the ::before backdrop visible)
        // and is only removed in closeNav().
        mMenuContainer.classList.add('navOpening');
        isOpening = true;
        startFlyoutTimer('openSettle', () => { isOpening = false; }, flyoutCloseAnim);
        // Position indicator instantly (no slide from nowhere)
        navIndicator.style.transition = 'none';
        positionIndicatorAt(index);
        navIndicator.offsetHeight; // force reflow
        navIndicator.style.transition = '';
        navIndicator.style.opacity = '1';
    } else {
        // Already open — crossfade panels, slide indicator
        isOpening = false;
        clearFlyoutTimer('openSettle');
        mMenuContainer.classList.add('navOpen');
        navIndicator.style.transition = '';
        positionIndicatorAt(index);
    }
}

function closeNav () {
    // Nothing open — bail early (the scroll handler calls this on every scroll)
    if (activeIndex < 0 &&
        !mMenuContainer.classList.contains('navOpen') &&
        !mMenuContainer.classList.contains('navOpening')) {
        return;
    }

    activeIndex = -1;
    isOpening = false;
    clearFlyoutTimer('openSettle');
    navItems.forEach(item => {
        item.classList.remove('hoverOn', 'wasHoverOn');
        item.querySelector(NAV_ITEM_NAME_ELE)?.setAttribute('aria-expanded', 'false');
    });
    mMenuContainer.classList.remove('navOpening', 'navOpen');

    // navClosing drives the reverse cascade; drop it once the animation ends
    mMenuContainer.classList.add('navClosing');
    startFlyoutTimer('closing', () => mMenuContainer.classList.remove('navClosing'), flyoutCloseAnim);

    navIndicator.style.opacity = '0';
}

// Leaving mid-reveal reverses immediately — a fly-by shouldn't fully open.
// Otherwise the close waits out the forgiveness delay.
function requestNavClose () {
    if (isOpening) {
        clearFlyoutTimer('close');
        closeNav();
        return;
    }

    startFlyoutTimer('close', closeNav, flyoutCloseDelay);
}

function positionIndicatorAt (index) {
    const navRect = mMenuContainer.getBoundingClientRect();
    const nameEl = navItems[index].querySelector(NAV_ITEM_NAME_ELE);
    if (!nameEl) return;
    const itemRect = nameEl.getBoundingClientRect();
    navIndicator.style.left = (itemRect.left - navRect.left) + 'px';
    navIndicator.style.width = itemRect.width + 'px';
}

// ─── Per-item event listeners ───
function bindNavItemEvents () {
    navItems.forEach((item, index) => {
        item.addEventListener('mouseenter', () => handleNavItemMouseEnter(index));
        item.addEventListener('mouseleave', handleNavItemMouseLeave);
        item.addEventListener('focusin', () => handleNavItemFocusIn(index));
        item.addEventListener('focusout', handleNavItemFocusOut);
        item.addEventListener('keydown', event => handleNavItemKeydown(event, item));
    });
}

function handleNavItemMouseEnter (index) {
    // Close the subnav supplementary menu and Klevu overlay (any viewport)
    closeSubNavSupplement();
    hideKlevuSearchOverlay();

    if (!isDesktopNavViewport()) return;

    clearFlyoutTimer('close');

    // Already open — switch immediately, no intent delay
    if (activeIndex >= 0) {
        clearFlyoutTimer('intent');
        openItem(index);
        return;
    }

    // First open — debounce to confirm intent
    startFlyoutTimer('intent', () => {
        if (isDesktopNavViewport()) {
            openItem(index);
        }
    }, flyoutIntentDelay);
}

function handleNavItemMouseLeave (event) {
    if (!isDesktopNavViewport()) return;

    clearFlyoutTimer('intent');

    // Moving within the nav is a switch, not a leave — let mouseenter
    // handle it (else switching mid-open causes a close→reopen flicker).
    if (event.relatedTarget && mMenuContainer.contains(event.relatedTarget)) {
        return;
    }

    requestNavClose();
}

function handleNavItemFocusIn (index) {
    if (!isDesktopNavViewport()) return;
    clearFlyoutTimer('close');
    // focusin bubbles from links inside the open panel; re-running
    // openItem() on the active item strips the previous panel's
    // wasHoverOn mid-crossfade (flicker on fast Tab traversal)
    if (index === activeIndex) return;
    openItem(index);
}

function handleNavItemFocusOut () {
    if (!isDesktopNavViewport()) return;
    // An outgoing panel going visibility:hidden briefly blurs focus to
    // <body>; only close once focus settles outside the nav
    setTimeout(() => {
        const focused = document.activeElement;
        if (focused && focused !== document.body && !mMenuContainer.contains(focused)) {
            closeNav();
        }
    }, FOCUS_SETTLE_DELAY);
}

function handleNavItemKeydown (event, item) {
    if (event.key !== 'Escape') return;
    closeNav();
    item.querySelector(NAV_ITEM_NAME_ELE)?.blur();
}

// ─── Container-level leave/enter ───
function bindContainerEvents () {
    mMenuContainer.addEventListener('mouseleave', handleNavContainerMouseLeave);
    mMenuContainer.addEventListener('mouseenter', handleNavContainerMouseEnter);
}

function handleNavContainerMouseLeave () {
    if (!isDesktopNavViewport()) return;
    if (activeIndex < 0) return; // already closed

    clearFlyoutTimer('intent');
    requestNavClose();
}

function handleNavContainerMouseEnter () {
    if (!isDesktopNavViewport()) return;
    // Re-enter within the forgiveness window cancels the pending close.
    clearFlyoutTimer('close');
}

//header-menu-suppliments temp menu option
function bindSubNavSupplements () {
    const navSubItem = document.querySelector('.gHeader-subNav-list-item');
    if (!navSubItem) return;

    const searchSubmit = document.querySelectorAll('.mix-sdpcForm-gHeaderSearchSubmit')[1];
    const subMenuItem = document.querySelectorAll('.gHeader-subNav-list-item__sub-menu__item')[1];
    const subMenu = document.querySelector('.gHeader-subNav-list-item__sub-menu');

    navSubItem.addEventListener('mouseenter', handleSubNavMouseEnter);
    navSubItem.addEventListener('mouseleave', handleSubNavClose);
    searchSubmit?.addEventListener('focusin', handleSubNavOpen);
    subMenuItem?.addEventListener('focusout', handleSubNavClose);
    //prevent premature closure of submenu
    subMenu?.addEventListener('click', e => { e.stopPropagation(); });
}

function isSubNavDesktopViewport () {
    return document.body.clientWidth >= subNavBreakPointWidth;
}

function openSubNavSupplement () {
    subNavTarget?.classList.add(CSS_SUB_NAV_ARROW);
    subNavMenuContainer?.classList.add(CSS_SUB_NAV_REVEAL);
}

function closeSubNavSupplement () {
    subNavTarget?.classList.remove(CSS_SUB_NAV_ARROW);
    subNavMenuContainer?.classList.remove(CSS_SUB_NAV_REVEAL);
}

function handleSubNavMouseEnter () {
    if (!isSubNavDesktopViewport()) return;
    openSubNavSupplement();
    // Close main nav items when supplementary menu opens
    closeNav();
    hideKlevuSearchOverlay();
}

function handleSubNavOpen () {
    if (!isSubNavDesktopViewport()) return;
    openSubNavSupplement();
}

function handleSubNavClose () {
    if (!isSubNavDesktopViewport()) return;
    closeSubNavSupplement();
}

// The Klevu search overlay mounts lazily, so it has to be re-queried at call time
function hideKlevuSearchOverlay () {
    const searchingArea = document.querySelector('#klevuSearchingArea');
    if (searchingArea) {
        searchingArea.style.display = 'none';
    }
}

function initViews () {
    gHeaderEle.removeEventListener('click', handleMobileHeaderClick, true);
    mainContainer.removeEventListener('click', handleDesktopHeaderClick, true);
    stopScrollDirectionChecker();

    if (isDesktopNavViewport()) {
        if (!scrollDirectionDisabled) {
            mainContainer.addEventListener('click', handleDesktopHeaderClick, true);
            window.addEventListener('scroll', scrollDirectionChecker, true);
        }
    } else {
        gHeaderEle.addEventListener('click', handleMobileHeaderClick, true);
    }
}

export function disableScrollDirectionChecker() {
    scrollDirectionDisabled = true;
    stopScrollDirectionChecker();
}

function stopScrollDirectionChecker () {
    window.removeEventListener('scroll', scrollDirectionChecker, true);
}

function scrollDirectionChecker() {
    if (scrollDirectionDisabled) return;

    // Close the desktop flyout on scroll (bails early until menus render)
    closeNav();

    let bodyTopPos = (document.body.getBoundingClientRect()).top;
    // Getting half of gHeader height and adding the height of the globalMessage element if present
    const pageTopOffset = -Number((gHeaderEle.offsetHeight/2) + (!document.querySelector(GLOBAL_MESSAGE_ELE) ? 0 : document.querySelector(GLOBAL_MESSAGE_ELE).offsetHeight));

    if (bodyTopPos > scrollPos || bodyTopPos >= pageTopOffset) {
        if (document.body.classList.contains('hideNav')) {
            document.body.classList.remove('hideNav');
        }
    } else  {
        if (!document.body.classList.contains('hideNav')) {
            document.body.classList.add('hideNav');
        }
    }
    scrollPos = bodyTopPos;
}

function handleDesktopHeaderClick (e) {
    if (e.target.matches(HEADER_AI_ACTION)) openHeaderIntelligence();
}

function handleMobileHeaderClick (e) {
    e.stopPropagation();
    const parentEle  = e.target.closest(TOGGLE_ELE);

    if (e.target.matches(TOGGLE_ACTION)) {
        e.preventDefault();
        !e.target.closest(HEADER_MAIN_ELE) || closeHeaderNav();

        //sub nav width for flex
        subNavMenuContainer?.classList.toggle(CSS_SUB_NAV_WIDTH)

        if (parentEle.classList.contains(CSS_IS_OPEN)) {
            closeParentMenu(e, parentEle);
        } else {
            closeMainMenus();
            openParentMenu(parentEle);
        }
        return;
    }

    if (e.target.matches(TOGGLE_SUP_MENU)) {
        subNavMenuContainer?.classList.toggle(CSS_SUB_NAV_REVEAL)
        //arrow toggle animation
        subNavTarget?.classList.toggle(CSS_SUB_NAV_ARROW)
        return;
    }

    if (e.target.matches(HEADER_NAV_ACTION)) {
        closeMainMenus();
        gutenbergService.close();
        mMenuTrigger.classList.contains(CSS_IS_OPEN) ? closeHeaderNav() : openHeaderNav();
        return;
    }

    if (e.target.matches(TOGGLE_CLOSE_ACTION)) {
        closeParentMenu(e, parentEle);
        subNavMenuContainer?.classList.remove(CSS_SUB_NAV_WIDTH)
        return;
    }

    if (e.target.matches(HEADER_AI_ACTION)) {
        openHeaderIntelligence();
        return;
    }
}

function closeParentMenu (e, parentEle) {
    parentEle.classList.remove(CSS_IS_OPEN);
}

function openParentMenu (parentEle) {
    parentEle.classList.add(CSS_IS_OPEN);
}

function openHeaderNav () {
    mMenuTrigger.classList.add(CSS_IS_OPEN)
    mMenuContainer.classList.add(CSS_IS_OPEN);
}

function closeHeaderNav () {
    closeHeaderNavMenus();
    mMenuTrigger.classList.remove(CSS_IS_OPEN)
    mMenuContainer.classList.remove(CSS_IS_OPEN);
    bodyLockService.unlock();
}

function closeMainMenus () {
    mainContainer.querySelectorAll(TOGGLE_ELE).forEach( toggle => {
        toggle.classList.remove(CSS_IS_OPEN);
    });
}

function closeHeaderNavMenus () {
    mMenuContainer.querySelectorAll(TOGGLE_ELE).forEach( toggle => {
        toggle.classList.remove(CSS_IS_OPEN);
    });
}

function openHeaderIntelligence () {
    gutenbergService.recordHeaderButtonClicked();
    gutenbergService.open();
}

function handleSearchInputKeydown (event) {
    if (event.key === "Tab") {
        hideKlevuSearchOverlay();
    }
}

document.querySelectorAll('.js--element-kSearchInput').forEach( trigger => {
    trigger.addEventListener('focus', closeSubNavSupplement);
    trigger.addEventListener('keydown', handleSearchInputKeydown);
})

//page_smartpress-intelligence button
function handleSiHeroClick () {
    gutenbergService.recordLandingHeroClicked();
    gutenbergService.open();
}

document.querySelector('.js--action-siHero')?.addEventListener('click', handleSiHeroClick);

Collaterate.User.getUser()
    .then(user => {
        if (user?.loyalty) {
            document.querySelector('.js--element-acountAsidePointContainer').style.display = 'block'
            document.querySelector('.js--element-accountAsidePoints').innerHTML = user.loyalty.availablePoints
        }
    })
